import { BfxFindFilterOperatorSet } from "../bfx-find/models/BfxFindFilterOperatorSet";

import { BfxFindFilterCondition } from "../bfx-find/models/BfxFindFilterCondition";

import { BfxFindOrdersFilterFieldName, CustomFieldLookupService } from "shared/cubiq-services";
import { BfxFindFilterConditionValueParseType } from "../bfx-find/models/BfxFindFilterConditionValueParseType";
import { FilterData } from "../bfx-find/bfx-find.constants";
import {
  BfxFindFilterDataFactory,
  BfxFindFilterData,
} from "../bfx-find/bfx-find-filter-data-factory";
import { Injectable } from "@angular/core";
import { BfxConfigService } from "../../shared/auth-services/system-config/bfx-config.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class BfxFindOrdersFilterDataFactory extends BfxFindFilterDataFactory {
  private oboEnabled: boolean = false;

  constructor(
    configService: BfxConfigService,
    customFieldService: CustomFieldLookupService,
    private translate: TranslateService,
  ) {
    super(customFieldService);

    configService.getUIConfig().then((config) => {
      this.oboEnabled = config && config.general ? config.general.oboEnabled : false;
    });
  }

  public defineFilterData(
    clientTraderUsersEnabled: boolean,
    fwdEnabled: boolean,
    ndfEnabled: boolean,
    benchmarksEnabled: boolean,
  ): BfxFindFilterData {
    let searchByClient: any = {};
    let searchByType: Partial<FilterData> = {
      id: FilterData.templateId++,
      label: "Search by Type",
    };
    searchByType.filterConditions = this.createOrderTypeFilterConditions(
      benchmarksEnabled,
      fwdEnabled,
      ndfEnabled,
    );

    let searchByDate: any = {};

    if (clientTraderUsersEnabled) {
      searchByClient = {
        id: FilterData.templateId++,
        label: "Search by Client",
        filterConditions: [
          new BfxFindFilterCondition(
            1,
            0,
            BfxFindOrdersFilterFieldName.CLIENT_ID,
            "Client ID",
            BfxFindFilterOperatorSet.In,
          ),
          new BfxFindFilterCondition(
            1,
            1,
            BfxFindOrdersFilterFieldName.CLIENT_NAME,
            "Client Name",
            BfxFindFilterOperatorSet.In,
          ),
          new BfxFindFilterCondition(
            1,
            2,
            BfxFindOrdersFilterFieldName.ACCOUNT_ID,
            "Account ID",
            BfxFindFilterOperatorSet.In,
          ),
          new BfxFindFilterCondition(
            1,
            3,
            BfxFindOrdersFilterFieldName.ACCOUNT_NAME,
            "Account Name",
            BfxFindFilterOperatorSet.In,
          ),
          new BfxFindFilterCondition(
            1,
            4,
            BfxFindOrdersFilterFieldName.CLIENT_TRADER,
            "Client Trader",
            BfxFindFilterOperatorSet.Equal,
          ),
          new BfxFindFilterCondition(
            1,
            5,
            BfxFindOrdersFilterFieldName.BRANCH,
            "Branch",
            BfxFindFilterOperatorSet.InNotIn,
          ),
          new BfxFindFilterCondition(
            1,
            6,
            BfxFindOrdersFilterFieldName.SALES_GROUP,
            "Sales Group",
            BfxFindFilterOperatorSet.EqualNotEqual,
          ),
          new BfxFindFilterCondition(
            1,
            7,
            BfxFindOrdersFilterFieldName.CHANNEL,
            "Channel",
            BfxFindFilterOperatorSet.InNotIn,
          ),
        ],
      };

      if (this.oboEnabled) {
        searchByClient.filterConditions.push(
          new BfxFindFilterCondition(
            1,
            8,
            BfxFindOrdersFilterFieldName.OBO_CLIENT,
            "OBO Client",
            BfxFindFilterOperatorSet.Equal,
            BfxFindFilterConditionValueParseType.RefString,
          ),
          new BfxFindFilterCondition(
            1,
            9,
            BfxFindOrdersFilterFieldName.OBO_ACCOUNT,
            "OBO Account",
            BfxFindFilterOperatorSet.Equal,
            BfxFindFilterConditionValueParseType.RefString,
          ),
        );
      }
    } else {
      searchByClient = {
        id: FilterData.templateId++,
        label: "Search by Client",
        filterConditions: [
          new BfxFindFilterCondition(
            1,
            0,
            BfxFindOrdersFilterFieldName.CLIENT_ID,
            "Client ID",
            BfxFindFilterOperatorSet.In,
          ),
          new BfxFindFilterCondition(
            1,
            1,
            BfxFindOrdersFilterFieldName.CLIENT_NAME,
            "Client Name",
            BfxFindFilterOperatorSet.In,
          ),
          new BfxFindFilterCondition(
            1,
            2,
            BfxFindOrdersFilterFieldName.ACCOUNT_ID,
            "Account ID",
            BfxFindFilterOperatorSet.In,
          ),
          new BfxFindFilterCondition(
            1,
            3,
            BfxFindOrdersFilterFieldName.ACCOUNT_NAME,
            "Account Name",
            BfxFindFilterOperatorSet.In,
          ),
          new BfxFindFilterCondition(
            1,
            4,
            BfxFindOrdersFilterFieldName.BRANCH,
            "Branch",
            BfxFindFilterOperatorSet.InNotIn,
          ),
          new BfxFindFilterCondition(
            1,
            5,
            BfxFindOrdersFilterFieldName.SALES_GROUP,
            "Sales Group",
            BfxFindFilterOperatorSet.EqualNotEqual,
          ),
          new BfxFindFilterCondition(
            1,
            6,
            BfxFindOrdersFilterFieldName.CHANNEL,
            "Channel",
            BfxFindFilterOperatorSet.InNotIn,
          ),
        ],
      };

      if (this.oboEnabled) {
        searchByClient.filterConditions.push(
          new BfxFindFilterCondition(
            1,
            7,
            BfxFindOrdersFilterFieldName.OBO_CLIENT,
            "OBO Client",
            BfxFindFilterOperatorSet.Equal,
            BfxFindFilterConditionValueParseType.RefString,
          ),
          new BfxFindFilterCondition(
            1,
            8,
            BfxFindOrdersFilterFieldName.OBO_ACCOUNT,
            "OBO Account",
            BfxFindFilterOperatorSet.Equal,
            BfxFindFilterConditionValueParseType.RefString,
          ),
        );
      }
    }

    if (benchmarksEnabled) {
      searchByDate = {
        id: FilterData.templateId++,
        label: "Search by Date or User",
        filterConditions: [
          new BfxFindFilterCondition(
            4,
            0,
            BfxFindOrdersFilterFieldName.SEARCH_IN_TZ,
            "Search in",
            BfxFindFilterOperatorSet.Equal,
            BfxFindFilterConditionValueParseType.None,
          ),
          new BfxFindFilterCondition(
            4,
            1,
            BfxFindOrdersFilterFieldName.ENTRY_DATE,
            "Entry Date",
            BfxFindFilterOperatorSet.All,
            BfxFindFilterConditionValueParseType.DateEquality,
          ),
          new BfxFindFilterCondition(
            4,
            2,
            BfxFindOrdersFilterFieldName.ENTRY_USER,
            "Entry User",
            BfxFindFilterOperatorSet.EqualNotEqual,
            BfxFindFilterConditionValueParseType.RefArray,
          ),
          new BfxFindFilterCondition(
            4,
            3,
            BfxFindOrdersFilterFieldName.MODIFY_DATE,
            "Modify Date",
            BfxFindFilterOperatorSet.All,
            BfxFindFilterConditionValueParseType.DateEquality,
          ),
          new BfxFindFilterCondition(
            4,
            4,
            BfxFindOrdersFilterFieldName.MODIFY_USER,
            "Modify User",
            BfxFindFilterOperatorSet.EqualNotEqual,
          ),
          new BfxFindFilterCondition(
            4,
            5,
            BfxFindOrdersFilterFieldName.CANCEL_DATE,
            "Cancel Date",
            BfxFindFilterOperatorSet.All,
            BfxFindFilterConditionValueParseType.DateEquality,
          ),
          new BfxFindFilterCondition(
            4,
            6,
            BfxFindOrdersFilterFieldName.CANCEL_USER,
            "Cancel User",
            BfxFindFilterOperatorSet.EqualNotEqual,
            BfxFindFilterConditionValueParseType.RefArray,
          ),
          new BfxFindFilterCondition(
            4,
            7,
            BfxFindOrdersFilterFieldName.FIXING_TIME,
            "Fixing Time",
            BfxFindFilterOperatorSet.All,
            BfxFindFilterConditionValueParseType.None,
            true,
            true,
          ),
          new BfxFindFilterCondition(
            4,
            8,
            BfxFindOrdersFilterFieldName.FIXING_DATE,
            "Fixing Date",
            BfxFindFilterOperatorSet.All,
            BfxFindFilterConditionValueParseType.DateEquality,
          ),
        ],
      };
    } else {
      searchByDate = {
        id: FilterData.templateId++,
        label: "Search by Date or User",
        filterConditions: [
          new BfxFindFilterCondition(
            4,
            0,
            BfxFindOrdersFilterFieldName.SEARCH_IN_TZ,
            "Search in",
            BfxFindFilterOperatorSet.Equal,
            BfxFindFilterConditionValueParseType.None,
          ),
          new BfxFindFilterCondition(
            4,
            1,
            BfxFindOrdersFilterFieldName.ENTRY_DATE,
            "Entry Date",
            BfxFindFilterOperatorSet.All,
            BfxFindFilterConditionValueParseType.DateEquality,
          ),
          new BfxFindFilterCondition(
            4,
            2,
            BfxFindOrdersFilterFieldName.ENTRY_USER,
            "Entry User",
            BfxFindFilterOperatorSet.EqualNotEqual,
            BfxFindFilterConditionValueParseType.RefArray,
          ),
          new BfxFindFilterCondition(
            4,
            3,
            BfxFindOrdersFilterFieldName.MODIFY_DATE,
            "Modify Date",
            BfxFindFilterOperatorSet.All,
            BfxFindFilterConditionValueParseType.DateEquality,
          ),
          new BfxFindFilterCondition(
            4,
            4,
            BfxFindOrdersFilterFieldName.MODIFY_USER,
            "Modify User",
            BfxFindFilterOperatorSet.EqualNotEqual,
          ),
          new BfxFindFilterCondition(
            4,
            5,
            BfxFindOrdersFilterFieldName.CANCEL_DATE,
            "Cancelled Date",
            BfxFindFilterOperatorSet.All,
            BfxFindFilterConditionValueParseType.DateEquality,
          ),
          new BfxFindFilterCondition(
            4,
            6,
            BfxFindOrdersFilterFieldName.CANCEL_USER,
            "Cancel User",
            BfxFindFilterOperatorSet.EqualNotEqual,
            BfxFindFilterConditionValueParseType.RefArray,
          ),
        ],
      };
    }

    let data = [
      {
        id: FilterData.templateId++,
        label: "Search by Reference",
        filterConditions: [
          new BfxFindFilterCondition(
            0,
            0,
            BfxFindOrdersFilterFieldName.ORDER_ID,
            "Order ID",
            BfxFindFilterOperatorSet.Equal,
            BfxFindFilterConditionValueParseType.ExclusiveRefString,
          ),
          new BfxFindFilterCondition(
            0,
            1,
            BfxFindOrdersFilterFieldName.TRADE_ID,
            "Trade ID",
            BfxFindFilterOperatorSet.Equal,
            BfxFindFilterConditionValueParseType.ExclusiveRefString,
          ),
          new BfxFindFilterCondition(
            0,
            2,
            BfxFindOrdersFilterFieldName.STRATEGY_ID,
            "Strategy ID",
            BfxFindFilterOperatorSet.Equal,
            BfxFindFilterConditionValueParseType.RefString,
          ),
          new BfxFindFilterCondition(
            0,
            3,
            BfxFindOrdersFilterFieldName.EXTERNAL_REF,
            "External Reference",
            BfxFindFilterOperatorSet.Equal,
            BfxFindFilterConditionValueParseType.RefString,
          ),
          new BfxFindFilterCondition(
            0,
            4,
            BfxFindOrdersFilterFieldName.BOOKING_UTI,
            "Booking UTI",
            BfxFindFilterOperatorSet.Equal,
            BfxFindFilterConditionValueParseType.ExclusiveRefString,
          ),
          new BfxFindFilterCondition(
            0,
            5,
            BfxFindOrdersFilterFieldName.NETTING_ID,
            "Spot Portfolio",
            BfxFindFilterOperatorSet.Equal,
            BfxFindFilterConditionValueParseType.ExclusiveRefString,
          ),
          new BfxFindFilterCondition(
            0,
            6,
            BfxFindOrdersFilterFieldName.FWD_NETTING_ID,
            "Forward Portfolio",
            BfxFindFilterOperatorSet.Equal,
            BfxFindFilterConditionValueParseType.ExclusiveRefString,
          ),
        ],
      },
      searchByClient,
      {
        id: FilterData.templateId++,
        label: "Search by Instrument",
        filterConditions: [
          new BfxFindFilterCondition(
            2,
            0,
            BfxFindOrdersFilterFieldName.CCY,
            "Ccy",
            BfxFindFilterOperatorSet.InNotIn,
          ),
          new BfxFindFilterCondition(
            2,
            1,
            BfxFindOrdersFilterFieldName.INSTRUMENT,
            "Instrument",
            BfxFindFilterOperatorSet.InNotIn,
          ),
          new BfxFindFilterCondition(
            2,
            2,
            BfxFindOrdersFilterFieldName.CCY_PAIR_GROUP,
            "Ccy Pair Group",
            BfxFindFilterOperatorSet.InNotIn,
            BfxFindFilterConditionValueParseType.InnerArray,
          ),
        ],
      },
      searchByType,
      searchByDate,
      {
        id: FilterData.templateId++,
        label: "Search by Amount",
        filterConditions: [
          new BfxFindFilterCondition(
            5,
            0,
            BfxFindOrdersFilterFieldName.ORDER_AMT,
            "Order Amt",
            BfxFindFilterOperatorSet.All,
          ),
          new BfxFindFilterCondition(
            5,
            1,
            BfxFindOrdersFilterFieldName.ORDER_AMT_USD,
            "Order Amt (USD)",
            BfxFindFilterOperatorSet.All,
          ),
          new BfxFindFilterCondition(
            5,
            2,
            BfxFindOrdersFilterFieldName.REMAINING_AMT,
            "Remaining Amt",
            BfxFindFilterOperatorSet.All,
          ),
          new BfxFindFilterCondition(
            5,
            3,
            BfxFindOrdersFilterFieldName.REMAINING_AMT_USD,
            "Remaining Amt (USD)",
            BfxFindFilterOperatorSet.All,
          ),
        ],
      },
      {
        id: FilterData.templateId++,
        label: "Search by Rate",
        filterConditions: [
          new BfxFindFilterCondition(
            6,
            0,
            BfxFindOrdersFilterFieldName.REQUEST_RT,
            "Request Rate",
            BfxFindFilterOperatorSet.All,
          ),
        ],
      },
      {
        id: FilterData.templateId++,
        label: "Search by State",
        filterConditions: [
          new BfxFindFilterCondition(
            7,
            0,
            BfxFindOrdersFilterFieldName.ORDER_STATE,
            "Order State",
            BfxFindFilterOperatorSet.InNotIn,
          ),
        ],
      },
    ];

    // If we have active custom fields, add the search panel and fields to the view
    const custFieldData = this.getCustomFieldSearchData();
    if (custFieldData) {
      data.push(custFieldData);
    }

    this.defaultTimezoneField(data);

    return {
      data: data,
    };
  }

  /**
   * Create all eligible filter conditions for the Find 'By Order Type' group
   * @param benchmarksEnabled
   * @param fwdEnabled
   * @param ndfEnabled
   * @returns
   */
  private createOrderTypeFilterConditions(
    benchmarksEnabled: boolean,
    fwdEnabled: boolean,
    ndfEnabled: boolean,
  ): BfxFindFilterCondition[] {
    const retValue: BfxFindFilterCondition[] = [];
    // consts so can fit constructors on single line...
    const inNotIn = BfxFindFilterOperatorSet.InNotIn;
    const fieldClass = BfxFindOrdersFilterFieldName;

    let label = this.translate.instant("find.filter.label.type.order.type");
    let position: number = 0;
    retValue.push(new BfxFindFilterCondition(3, position++, fieldClass.TYPE, label, inNotIn));

    if (ndfEnabled || fwdEnabled || benchmarksEnabled) {
      label = this.translate.instant("find.filter.label.type.product");
      retValue.push(new BfxFindFilterCondition(3, position++, fieldClass.PRODUCT, label, inNotIn));
    }
    if (benchmarksEnabled) {
      label = this.translate.instant("find.filter.label.type.bm.fixing");
      retValue.push(
        new BfxFindFilterCondition(3, position++, fieldClass.BM_FIXCODE, label, inNotIn),
      );
    }
    if (ndfEnabled) {
      label = this.translate.instant("find.filter.label.type.ndf.fixing");
      retValue.push(new BfxFindFilterCondition(3, position++, fieldClass.FIXCODE, label, inNotIn));
    }
    if (benchmarksEnabled) {
      label = this.translate.instant("find.filter.label.type.bm.spawned");
      retValue.push(
        new BfxFindFilterCondition(
          3,
          position++,
          fieldClass.BM_SPAWNED,
          label,
          BfxFindFilterOperatorSet.Equal,
          BfxFindFilterConditionValueParseType.TrueFalse,
        ),
      );
      label = this.translate.instant("find.filter.label.type.bm.forwardfirst");
      const condition = new BfxFindFilterCondition(
        3,
        position++,
        fieldClass.BM_FORWARD_FIRST,
        label,
        BfxFindFilterOperatorSet.Equal,
        BfxFindFilterConditionValueParseType.None,
      );
      retValue.push(condition);
    }

    return retValue;
  }
}
